export const occupations = [
  'Ayudante de Albañilería',
  'Director Presidente',
  'Abogada',
  'Accionista',
  'Acoplador Gráfico',
  'Administrador',
  'Administrador General',
  'Administradora',
  'Administradora de Obra',
  'Administradora de Proyectos',
  'Agente Comercial y de Suministros',
  'Agente Inmobiliario',
  'Albañil',
  'Albañil de 1ra.',
  'Albañil Oficial',
  'Almacenista de Producción',
  'Analista Comercial',
  'Analista de  SAC',
  'Analista de Calidad',
  'Analista de Cobranzas',
  'Analista de Comercio Exterior Pleno',
  'Analista de Compras Junior',
  'Analista de Compras Pleno',
  'Analista de Control de Calidad Jr.',
  'Analista de Convenios y Eventos',
  'Analista de Costos Júnior',
  'Analista de Costos Pleno',
  'Analista de Costos Senior',
  'Analista de Créditos',
  'Analista de Desarrollo Web',
  'Analista de E-Commerce',
  'Analista de Finanzas',
  'Analista de Marketing',
  'Analista de Métodos y Procesos',
  'Analista de O&M',
  'Analista de PCP',
  'Analista de Proyectos',
  'Analista de Recursos Humanos',
  'Analista de Selección',
  'Analista de Sistemas',
  'Analista de Sistemas de Gestión Integrada',
  'Analista de Sistemas y Tecnología',
  'Analista Programador',
  'Anfitriona',
  'Apoderada',
  'Apoderado',
  'Apoderado de Recursos Humanos',
  'Aprendiz',
  'Apuntador',
  'Arquitecta',
  'Arquitecto',
  'Asesor de Ventas',
  'Asesora Contable',
  'Asesora de ventas',
  'Asistente Administrativa',
  'Asistente Administrativa Contable',
  'Asistente Administrativo',
  'Asistente Administrativo & Comercial',
  'Asistente Comercial',
  'Asistente Contable',
  'Asistente de Administración',
  'Asistente de Calidad',
  'Asistente de Catastro',
  'Asistente de Comercio Exterior',
  'Asistente de Compras',
  'Asistente de Contabilidad',
  'Asistente de Contraloria',
  'Asistente de Créditos & Cobranzas',
  'Asistente de Cuentas Publicitárias',
  'Asistente de Depósito',
  'Asistente de Depósitos',
  'Asistente de Directorio',
  'Asistente de Expedición',
  'Asistente de Facturación',
  'Asistente de Importación',
  'Asistente de Informática',
  'Asistente de Logística',
  'Asistente de Marketing',
  'Asistente de Monitoreo',
  'Asistente de PCP',
  'Asistente de Presupuesto',
  'Asistente de Procesos - BPM',
  'Asistente de Producción',
  'Asistente de Recursos Humanos',
  'Asistente de Servicio al Cliente',
  'Asistente de Tesorería',
  'Asistente de Tienda',
  'Asistente de Tienda - Jornada Parcial',
  'Asistente de Ventas',
  'Asistente Financiero',
  'Atención al Cliente',
  'Auditor',
  'Auditor Contable',
  'Auditor Externo',
  'Auxiliar ADM',
  'Auxiliar Adm. & Financiero',
  'Auxiliar Administratativo',
  'Auxiliar Administrativa',
  'Auxiliar Administrativo',
  'Auxiliar Administrativo & Comercial',
  'Auxiliar Administrativo I',
  'Auxiliar Administrativo II',
  'Auxiliar Comercial',
  'Auxiliar Contable',
  'Auxiliar de Atención al Cliente',
  'Auxiliar de Auditoria',
  'Auxiliar de Calidad',
  'Auxiliar de Carpintería',
  'Auxiliar de Catastro',
  'Auxiliar de Catastro Y Ruteo',
  'Auxiliar de Cobranzas',
  'Auxiliar de Comércio Exterior',
  'Auxiliar de Comercio Exterior Júnior',
  'Auxiliar de Comercio Exterior Pleno',
  'Auxiliar de Comércio Exterior Senior',
  'Auxiliar de Compras',
  'Auxiliar de Contabilidad',
  'Auxiliar de Contabilidad Junior',
  'Auxiliar de Contabilidad Pleno',
  'Auxiliar de Contabilidad Senior',
  'Auxiliar de Control de Calidad Júnior',
  'Auxiliar de Control de Calidad Pleno',
  'Auxiliar de Control de Calidad Senior',
  'Auxiliar de Control de Compras',
  'Auxiliar de Créditos & Cobranzas',
  'Auxiliar de Cuentas Corrientes',
  'Auxiliar de Depósio',
  'Auxiliar de Depósito',
  'Auxiliar de Directorio',
  'Auxiliar de Directorio Jr.',
  'Auxiliar de Electricista',
  'Auxiliar de Encargado',
  'Auxiliar de Expedición',
  'Auxiliar de Facturación',
  'Auxiliar de Importación',
  'Auxiliar de Impresión - Maq 600',
  'Auxiliar de Informática',
  'Auxiliar de Insumos',
  'Auxiliar de Limpieza',
  'Auxiliar de Logística',
  'Auxiliar de Mantenimiento',
  'Auxiliar de Mantenimiento Edilicio',
  'Auxiliar de Mantenimiento I',
  'Auxiliar de Mantenimiento Industrial',
  'Auxiliar de Mantenimiento Mecánico',
  'Auxiliar de Maquinista',
  'Auxiliar de Marketing',
  'Auxiliar de Mecánico',
  'Auxiliar de Metalurgia',
  'Auxiliar de Monitoreo',
  'Auxiliar de Montaje',
  'Auxiliar de Operador',
  'Auxiliar de PCP',
  'Auxiliar de PCP Júnior',
  'Auxiliar de PCP Pleno',
  'Auxiliar de PCP Senior',
  'Auxiliar de Pintura',
  'Auxiliar de Procesos Industrial',
  'Auxiliar de Producción',
  'Auxiliar de Producción - (Abastecimiento)',
  'Auxiliar de Producción - (Etiquetados)',
  'Auxiliar de Producción - (Recuperación)',
  'Auxiliar de Producción - (Revisión)',
  'Auxiliar de Producción Metalurgía',
  'Auxiliar de Producción Verificador',
  'Auxiliar de Proyectos',
  'Auxiliar de Reciclaje',
  'Auxiliar de Recuperación de Créditos',
  'Auxiliar de Recursos Humanos',
  'Auxiliar de Recursos Humanos Júnior',
  'Auxiliar de Recursos Humanos Pleno',
  'Auxiliar de Recursos Humanos Senior',
  'Auxiliar de Servicios',
  'Auxiliar de Servicios Generales',
  'Auxiliar de Servicios I',
  'Auxiliar de Servicios II',
  'Auxiliar de Supervision',
  'Auxiliar de Tesorería',
  'Auxiliar de Ventas',
  'Auxiliar Financiero',
  'Auxiliar Financiero Júnior',
  'Auxiliar Financiero Pleno',
  'Auxiliar Financiero Senior',
  'Auxiliar Gráfico',
  'Auxiliar Legal',
  'Auxiliar Proyectista',
  'Auxiliar Técnico',
  'Auxiliar Técnico de Informática',
  'Auxiliar Técnico en Infornática',
  'Auxiliar Técnico Industrial',
  'Ayudante de Albañilería',
  'Ayudante de Carpintería',
  'Ayudante de Cocina',
  'Ayudante de Depósito',
  'Ayudante de Electricidad',
  'Ayudante de Electricista',
  'Ayudante de Electricista Industrial',
  'Ayudante de Herrería',
  'Ayudante de Herrero',
  'Ayudante de Limpieza',
  'Ayudante de Llaves',
  'Ayudante de Logística',
  'Ayudante de Mantenimiento',
  'Ayudante de Mecánico',
  'Ayudante de Mecánico Industrial',
  'Ayudante de Obra',
  'Ayudante de Operador de Maquinas',
  'Ayudante de Pintura',
  'Ayudante de Pizzería',
  'Ayudante de Plomería',
  'Ayudante de Producción',
  'Ayudante de Producción I',
  'Ayudante de Producción II',
  'Ayudante de Producción III',
  'Ayudante de Producción Mant. Máquinas',
  'Ayudante de Silo',
  'Ayudante de Suministros',
  'Ayudante Llavero',
  'Bachera',
  'Bachero',
  'Bartender',
  'Basculero',
  'Boyero',
  'Bra Especialist',
  'Business Intelligence',
  'Cabillero Calificado',
  'Cabillero de 1ra.',
  'Cabillero Oficial',
  'Cajera',
  'Cajera Principal',
  'Cajera/o',
  'Cajero',
  'Capataz de Estancia',
  'Carpintero',
  'Carpintero de 1ra.',
  'Carpintero Oficial',
  'Category Supervisor',
  'CEO',
  'Ceramiquero de 1ra.',
  'Chef',
  'Chofer',
  'Chofer - Repartidor',
  'Chofer Ayudante',
  'Chofer ce Camióm',
  'Chofer de Camión',
  'Chofer de Carreta',
  'Chofer del Directorio',
  'Chofer Externo',
  'Chofer Presidencial',
  'Chofer Repartidor',
  'Cobrador',
  'Cocinera',
  'Cocinero',
  'Colorista Textil',
  'Composto',
  'Comprador',
  'Conferente',
  'Consultor Comecial',
  'Consultor Comercial',
  'Consultor de Recursos Humanos Júnior',
  'Consultor de Recursos Humanos Pleno',
  'Consultor de Recursos Humanos Senior',
  'Consultor Industrial',
  'Consultor Jefe Regional - Asunción',
  'Consultor Regional de Recursos Humanos',
  'Consultor Técnico Comercial',
  'Contador',
  'Contadora',
  'Content Manager',
  'Contralor General',
  'Control de Calidad Mascarillas',
  'Control de Calidad TNT',
  'Coordinador',
  'Coordinador Administrativo',
  'Coordinador Comercial',
  'Coordinador de Compras',
  'Coordinador de Gestión de Calidad',
  'Coordinador de Obra',
  'Coordinador de PCP',
  'Coordinador/a de calidad',
  'Coordinadora de Marketing',
  'Creador de Contenido',
  'Depositario',
  'Depositario Calificado',
  'Depositario Oficial',
  'Depósito MP',
  'Director',
  'Director Accionista',
  'Director Administrativo',
  'Director Apoderado',
  'Director Comercial',
  'Director de Obras',
  'Director de Operaciones',
  'Director de Proyectos',
  'Director Ejecutivo & de Negócios',
  'Director General',
  'Director Industrial',
  'Director Presidente',
  'Director Titular',
  'Director Titular- CEO',
  'Director/a',
  'Directora',
  'Directora Comercial',
  'Directora de Finanzas',
  'Directora de Operaciones & Marketing',
  'Directora Titular',
  'Directorio',
  'Diseñador',
  'Diseñador Gráfico',
  'Diseñador Gráfico Júnior',
  'Diseñador Personalizado',
  'Distribucion',
  'Ejecutivo de Cuentas',
  'Ejecutivo de Negocios',
  'Ejecutivo de Operaciones',
  'Electricista',
  'Electricista - Ploteador',
  'Electricista Calificado',
  'Electricista de 1ra.',
  'Electricista Industrial',
  'Electricista Oficial',
  'Empleada Doméstica',
  'Enc. de Originación de Créditos y Granos',
  'Encargada Administrativa',
  'Encargada de Administración',
  'Encargada de Call Center',
  'Encargada de Cuenta',
  'Encargada de Cuentas Corrientes',
  'Encargada de Idiomas',
  'Encargada de Importación y Exportación',
  'Encargada de Limpieza',
  'Encargada de Presupuesto',
  'Encargada de Recursos Humanos',
  'Encargada de Salón',
  'Encargada de Tesorería',
  'Encargada de Vitrina',
  'Encargado Administrativo',
  'Encargado Asistencia Tecnica',
  'Encargado Comercial',
  'Encargado de Accesorios',
  'Encargado de Carpintería',
  'Encargado de Cobranzas',
  'Encargado de Cocina',
  'Encargado de Comércio Exterior',
  'Encargado de Compliance',
  'Encargado de Compras',
  'Encargado de Contabilidad',
  'Encargado de Control de Calidad',
  'Encargado de Créditos',
  'Encargado de Depósito',
  'Encargado de Depóstio',
  'Encargado de Devoluciones',
  'Encargado de Elásticos',
  'Encargado de Expedición',
  'Encargado de Exportación',
  'Encargado de Facturación',
  'Encargado de Importación',
  'Encargado de Limpieza',
  'Encargado de Logística',
  'Encargado de Mantenimiento',
  'Encargado de Mantenimiento Edilicio',
  'Encargado de Mantenimiento Eléctrico',
  'Encargado de Mantenimiento Mecánico',
  'Encargado de Marketing',
  'Encargado de Mezclado',
  'Encargado de Operaciones',
  'Encargado de PCP',
  'Encargado de Planta',
  'Encargado de Producción',
  'Encargado de Sala',
  'Encargado de Sector',
  'Encargado de Seguridad',
  'Encargado de Seguridad Ocupacional',
  'Encargado de Seguridad Patrimonial',
  'Encargado de Servicios',
  'Encargado de Siembra',
  'Encargado de Sucursal',
  'Encargado de Tienda',
  'Encargado de Transportadora',
  'Encargado de Transportes & Expedición',
  'Encargado de Turismo',
  'Encargado del Depósito',
  'Encargado del Depósito de Insumos',
  'Encargado del Depósito de Matéria Prima',
  'Encargado del Sector Blanco',
  'Encargado del Sector de TNT',
  'Encargado E-Commerce',
  'Encargado Financiero',
  'Encargado Mantenimiento  - Tapabocas',
  'Encargado/a',
  'Encargado/a de Regencia',
  'Enfermera',
  'Enfermero',
  'Escaparatista',
  'Fletero',
  'Fumigador',
  'Gcia. de Recursos Humanos',
  'General Manager',
  'Gerente',
  'Gerente Administrativo',
  'Gerente Administrativo & Financiero',
  'Gerente Administrativo Financiero',
  'Gerente Agrícola',
  'Gerente Comercial',
  'Gerente Contable',
  'Gerente de Compras',
  'Gerente de Créditos & Cobranza',
  'Gerente de Estancia',
  'Gerente de Fábrica',
  'Gerente de Logística',
  'Gerente de Marketing',
  'Gerente de Mascarillas',
  'Gerente de Obra',
  'Gerente de Obras',
  'Gerente de Operaciones',
  'Gerente de Producción',
  'Gerente de Recursos Humanos',
  'Gerente de Tecnología',
  'Gerente de Tecnología & Inform',
  'Gerente de Tienda',
  'Gerente de Ventas',
  'Gerente Financiero',
  'Gerente General',
  'Gerente Industrial',
  'Gestor  de Asistencia Tecnica',
  'Gestor Administrativo',
  'Gestor Comercial',
  'Gestor Comercial Electronico',
  'Gestor Contable',
  'Gestor de Bebidas',
  'Gestor de Cobranzas',
  'Gestor de Cobranzas & Ventas',
  'Gestor de Compras Exterior',
  'Gestor de Control de Compras',
  'Gestor de Distribucion',
  'Gestor de Juguetería',
  'Gestor de Logistica',
  'Gestor de Logistica Internacional',
  'Gestor de Moda Casual',
  'Gestor de Moda Deportiva',
  'Gestor de Moda Infantil',
  'Gestor de Modas',
  'Gestor de Perfumeria',
  'Gestor de Pesca y Aventura',
  'Gestor de Publicidad y Propaganda',
  'Gestor de Recursos Humanos',
  'Gestor de Siniestros y Atención a Clientes',
  'Gestor Financiero',
  'Gestora de Depósito',
  'Gestora Operacional',
  'Gte. de Recursos Humanos',
  'Guarda Volumen',
  'Guardia de Seguridad',
  'Guardía de Seguridad Patrimonial',
  'Herramentista - Prensa',
  'Herrero',
  'Herrero de 1ra.',
  'Ingeniería Industrial',
  'Ingeniería Informática',
  'Ingenierio de Mantenimiento',
  'Ingeniero  Civil',
  'Ingeniero Civil',
  'Ingeniero de Mantenimiento',
  'Ingeniero de Productos',
  'Ingeniero Mecánico',
  'Ingeniero Metalúrgico',
  'Inspector de Calidad Jr',
  'Inspector de Calidad Júnior',
  'Inspector de Calidad Pleno',
  'Inspector de Calidad Senior',
  'Inspector de Control de Calidad',
  'Inspector de Control de Calidad Júnior',
  'Inspector de Control de Calidad Pleno',
  'Inspector de Control de Calidad Senior',
  'Inspector Jefe de Calidad',
  'Inspector Jefe de Seguridad Ocupacional',
  'Instructor de Drones',
  'Intercambiador de Moldes',
  'Jardinero',
  'Jefe  de Administración de Proyectos',
  'Jefe Administrativo & Contable',
  'Jefe Administrativo & Financiero',
  'Jefe de Administración de Proyectos',
  'Jefe de Auditoria Externa',
  'Jefe de Carpintería',
  'Jefe de Compras',
  'Jefe de Logística',
  'Jefe de Pintura',
  'Jefe de Planta',
  'Jefe de Producción',
  'Jefe de Productos',
  'Jefe de Sector',
  'Jefe de Seguridad',
  'Jefe de Seguridad Patrimonial',
  'Jefe del Dpto. de Compras',
  'Jefe del Dpto. de Contabilidad',
  'Jefe del Dpto. de Corte Textil',
  'Jefe del Dpto. de Costos',
  'Jefe del Dpto. de Estampería',
  'Jefe del Dpto. de Inyección',
  'Jefe del Dpto. de Logística',
  'Jefe del Dpto. de Mant. Industrial',
  'Jefe del Dpto. de Matricería',
  'Jefe del Dpto. de Montaje',
  'Jefe del Dpto. de PCP',
  'Jefe del Dpto. de Reciclaje',
  'Jefe del Dpto. de Rotomoldeo',
  'Jefe Dpto. de Contabilidad',
  'Jefe Financiero',
  'Jornalero',
  'Legal',
  'Líder de Depósito',
  'Líder de Expedición',
  'Líder de Ingeniería',
  'Líder de Inspección de Calidad',
  'Líder de Línea de Montaje',
  'Líder de Logística - Exportación',
  'Líder de Mantenimiento',
  'Líder de Metalurgía',
  'Líder de Montaje',
  'Lìder de Producción',
  'Líder de Separación',
  'Líder de Turno de Hornos',
  'Líder de Turno de Inyección',
  'Líder de Turno de Producción',
  'Líder T1',
  'Líder T4',
  'Limpiador',
  'Limpiadora',
  'Limpieza',
  'Llavero',
  'Llavero Oficial',
  'Locutor Comercial',
  'Maestro de obra',
  'Maquinista',
  'Matricero',
  'Matricero Júnior',
  'Matricero Pleno',
  'Matricero Trainee',
  'Mecánico',
  'Mecánico de Máquinas',
  'Mecánico de Vehículos',
  'Mecánico Industrial',
  'Mecánico Industrial Pleno',
  'Metalúrgico',
  'Mezclador de Matéria Prima',
  'Moldeador',
  'Montador',
  'Montador Calificado',
  'Montador de Tiendas',
  'Montador Oficial',
  'Moza',
  'Mozo',
  'Oficial',
  'Oficial de Créditos JR',
  'Oficial de Créditos SR',
  'Oficial de Mantenimiento',
  'Oficial de Matricería Pleno',
  'Oficial de Matricería Senior',
  'Oficial de Metalurgía Júnior',
  'Oficial Mecánico',
  'Oficial Metalúrgico',
  'Operador Calificado',
  'Operador de 1ra.',
  'Operador de Acopladora',
  'Operador de Caldera',
  'Operador de Call Center',
  'Operador de Corte & Doblado',
  'Operador de Cosechadora',
  'Operador de Equipos Gráficos',
  'Operador de Extrusora',
  'Operador de Fumigadora',
  'Operador de Grúa de 1ra.',
  'Operador de Grúa Móvel',
  'Operador de Horno',
  'Operador de Impresión - Maq 600',
  'Operador de Máquina',
  'Operador de Máquina Acopladora',
  'Operador de Máquina Industrial',
  'Operador de Máquina Inyectora',
  'Operador de máquinas',
  'Operador de Máquinas de Prensa',
  'Operador de Máquinas Extrusoras',
  'Operador de Máquinas Textiles',
  'Operador de Mezcladora',
  'Operador de Molino',
  'Operador de Montacarga',
  'Operador de Montacargas',
  'Operador de Montacargas Trainne',
  'Operador de Prensa',
  'Operador de Producción',
  'Operador de Sopladora',
  'Operador de Televentas',
  'Operador de Torno CNC',
  'Operador Oficial',
  'Operador Traiding',
  'Operardor de máquinas',
  'Operativo de Marketing',
  'Pasante de Proyectos',
  'Pasante Legal',
  'Pintor',
  'Pizzero',
  'Plomero',
  'Plomero Calificado',
  'Plomero de 1ra.',
  'Plomero Oficial',
  'Ploteador',
  'Ploteador - Tensador',
  'Presidente',
  'Producción',
  'Product Manager',
  'Profesional',
  'Profesional de PCP',
  'Profesional Independiente en Marketing',
  'Programador',
  'Programador de Sistemas',
  'Programador de Torno CNC',
  'Promotor',
  'Promotor de Ventas',
  'Promotor Repositor',
  'Promotora',
  'Promotora de Pascuas',
  'Proyectista',
  'Puntero Cabillero',
  'Puntero de Albañilería',
  'Puntero de Electricidad',
  'Puntero de Estructura',
  'Puntero de Herrería',
  'Puntero de Montaje',
  'Puntero de Obras',
  'Puntero de Plomería',
  'Puntero Montador',
  'Recepcionista',
  'Redactor',
  'Regente',
  'Regulador de Máquinas',
  'Regulador de Máquinas Trainee',
  'Repartidor',
  'Repositor (a)',
  'Representante Comercial',
  'Representante de Ventas',
  'Representante Legal',
  'Secretaria',
  'Secretaria del Directório',
  'Secretaria Recepcionista',
  'Seguridad',
  'Separador',
  'Separador de Mercaderías',
  'Separador de Productos',
  'Servicio de Atención al Cliente',
  'Servicios Generales',
  'Social Media',
  'Socio - Director',
  'Soldador',
  'Soldador de 1ra.',
  'Soldador Industrial',
  'Soldador TIG',
  'Soporte Técnico',
  'Sub Chef',
  'Sub Encargado De Depósito',
  'Sub Encargado de Tienda & Caja',
  'Sub Encargado de Tienda & Ventas',
  'Sub Encargado de Turno',
  'Sub Gerente',
  'Supervisor',
  'Supervisor Administrativo',
  'Supervisor Comercial',
  'Supervisor Contable',
  'Supervisor de Albañilería',
  'Supervisor de Asistencia Tecnica',
  'Supervisor de Auditoría',
  'Supervisor de Cajas',
  'Supervisor de Catastro',
  'Supervisor de Cobranzas',
  'Supervisor de Condominio',
  'Supervisor de Control de Calidad',
  'Supervisor de Estructura',
  'Supervisor de Expedición',
  'Supervisor de Instalaciones',
  'Supervisor de Línea',
  'Supervisor de Logística',
  'Supervisor de marca',
  'Supervisor de Marcas',
  'Supervisor de Monitoreo',
  'Supervisor de Operación / Atención en Salón',
  'Supervisor de Operaciones',
  'Supervisor de Producción',
  'Supervisor de Publicidad y Propaganda',
  'Supervisor de Sala',
  'Supervisor de Sucursal Encarnación',
  'Supervisor de Televentas',
  'Supervisor de Terminaciones',
  'Supervisor de Urbanismo',
  'Supervisor de Ventas',
  'Supervisor Financiero',
  'Supervisor General',
  'Supervisor Junior de Acabados',
  'Supervisor Junior de Urbanismo',
  'Supervisor Regional I',
  'Supervisor Regional II',
  'Supervisor Regional III',
  'Supervisor Regional IV',
  'Supervisora',
  'Supervisora de Acabados',
  'Supervisora de Áreas Exteriores',
  'Supervisora de condominio',
  'Supervisora de E-Commerce',
  'Supervisora de Operaciones',
  'Supervisora de Operaciones / Caja',
  'Supervisora de Post Ventas y Reclamos',
  'Supervisora de Recursos Humanos',
  'Supervisora de Sala',
  'Supervisora de Servicio al Cliente',
  'Supervisora de Ventas',
  'Supervisora en Post Ventas y Reclamos',
  'Taxista',
  'Tècnico',
  'Técnico & Proyectista de Ultrasonido',
  'Técnico de Impresoras Offset',
  'Técnico de Mantenimiento',
  'Técnico de Mantenimiento Industrial',
  'Técnico de Mascarillas',
  'Técnico de Seguridad en Salud Ocupacional',
  'Técnico de Seguridad Ocupacional',
  'Técnico de Servicios',
  'Técnico de Soporte en TI - Desk Help',
  'Técnico de Soporte Informático Júnior',
  'Técnico de Soporte Informático Pleno',
  'Técnico de Soporte Informático Senior',
  'Técnico en Informática',
  'Técnico en Seguridad Ocupacional',
  'Técnico Gráfico',
  'Técnico Industrial',
  'Técnico Matricero',
  'Telemarketer',
  'Tesorero',
  'Tornero',
  'Tractorista',
  'Vaquero',
  'Vendedor',
  'Vendedor de Repuestos',
  'Vendedor de Salón',
  'Vendedor E-Commerce',
  'Vendedor Externo',
  'Vendedor Interno',
  'Vendedora',
  'Vendedora Comisionista',
  'Vendedora de Salón',
  'Vendedora E-Commerce',
  'Ventas e-commerce',
  'Verificador',
  'Vicepresidente',
  'Vigilante de Monitoreo',
  'Visual Supervisor',
  'Zafrero',
]
